import React, { Component } from 'react'
import PropTypes from 'prop-types'

const humanize = field => field.split('_').map(word => {
  return word[0].toUpperCase() + word.substr(1)
}).join(' ')

export default class DynamicFieldPicker extends Component {
  static propTypes = {
    dynamicFields: PropTypes.arrayOf(PropTypes.string).isRequired,
    onPick: PropTypes.func.isRequired
  }

  handleClick = event => {
    event.preventDefault()
    this.props.onPick(event.target.dataset.field)
  }

  render() {
    return (
      <div className="dynamic-field-picker">
        <div style={{fontWeight: 'bold', textAlign: 'center', margin: '10px 0 20px'}}>Please choose a field.</div>
        <ul>
          {this.props.dynamicFields.map(field => (
            <li key={field} data-field={field} onClick={this.handleClick}>
              {humanize(field)}
            </li>
          ))}
        </ul>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// client/components/sections/website/settings/Form/RichText/controls/dynamic_field_picker.js